import InnerComponent from '@Components/Inventory/StockTransfer/GrnForm';
import orgContainer from '@Components/AppContainer';

const UpdateStGrnPage = () => ((orgContainer(InnerComponent)));
export default UpdateStGrnPage;
